import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { QuestionList } from './components';

const QuestionsView = ({ button }) => {
  const { t } = useTranslation();

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'navigate',
      },
      '*'
    );
  }, []);

  return (
    <>
      <h3>{t('questions.header')}</h3>
      <QuestionList button={button} />
    </>
  );
};

export default QuestionsView;
